import fontSize from './fontSize'
import fontWeight from './fontWeight'
import lineHeight from './lineHeight'

const textScale = {
    H1: {
        fontSize: fontSize.xxxxl,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.xxxxl,
    },
    H2: {
        fontSize: fontSize.xxxl,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.xxxl,
    },
    H3: {
        fontSize: fontSize.xxl,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.xxl,
    },
    H4: {
        fontSize: fontSize.xl,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.l,
    },
    bodyL400: {
        fontSize: fontSize.l,
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight.xl,
    },
    bodyL500: {
        fontSize: fontSize.l,
        fontWeight: fontWeight.medium,
        lineHeight: lineHeight.xl,
    },
    bodyL700: {
        fontSize: fontSize.l,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.xl,
    },
    bodyM400: {
        fontSize: fontSize.m,
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight.l,
    },
    bodyM500: {
        fontSize: fontSize.m,
        fontWeight: fontWeight.medium,
        lineHeight: lineHeight.l,
    },
    bodyM700: {
        fontSize: fontSize.m,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.l,
    },
    bodyS400: {
        fontSize: fontSize.s,
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight.m,
    },
    bodyS500: {
        fontSize: fontSize.s,
        fontWeight: fontWeight.medium,
        lineHeight: lineHeight.m,
    },
    bodyS700: {
        fontSize: fontSize.s,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.m,
    },
    caption400: {
        fontSize: fontSize.xs,
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight.xxs,
    },
    caption500: {
        fontSize: fontSize.xs,
        fontWeight: fontWeight.medium,
        lineHeight: lineHeight.xxs,
    },
    caption700: {
        fontSize: fontSize.xs,
        fontWeight: fontWeight.bold,
        lineHeight: lineHeight.xxs,
    },
}

export default textScale
export type TextScale = typeof textScale
